import _ from 'lodash';
import moment, { Moment } from 'moment';
import React, { useMemo } from 'react';

import { OpenSlotCard } from '../../cards/open-slot-card';
import { collateDuplicateShifts } from '../../components/roster-utilities';
import { IRosterShift } from '../../types';
import { Stack } from '@good/ui/core';
import { ROSTER_TAB } from 'views/bookings-v2/bookings-roster-view/components/roster-common-enums';

interface OpenSlotCardListProps {
  shifts?: IRosterShift[];
  day: Moment;
}

export const OpenSlotCardList = ({ shifts, day }: OpenSlotCardListProps) => {
  const shiftsForDay = _.chain(shifts)
    .filter((shift) => moment(shift.shiftStartDateTime).isSame(day, 'day'))
    .orderBy(['serviceName', 'startDateTime'], ['asc', 'asc'])
    .value();
  const collatedShifts = useMemo(() => collateDuplicateShifts(shiftsForDay), [shiftsForDay]); // TODO : Maybe this can be optimised to be grouped by the API instead of the frontend.

  return (
    <Stack gap='xs'>
      {_.map(collatedShifts, (shift, idx) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
        <OpenSlotCard shift={shift} key={idx} tab={ROSTER_TAB.WEEKLY} />
      ))}
    </Stack>
  );
};
